import lf from 'localforage'
import ld from 'lodash'

export const initStorage = async () => {
  const curBook = await lf.getItem('cur_book')
  const allBooks = await lf.getItem('all_books')
  const sMode = await lf.getItem('s_mode')
  const sQuiz = await lf.getItem('s_quiz')
  const sText = await lf.getItem('s_text')
  const sLs = await lf.getItem('s_ls')
  const sLno = await lf.getItem('s_lno')

  if (curBook === null) {
    await lf.setItem('cur_book', '')
  }
  if (allBooks === null) {
    await lf.setItem('all_books', [])
  }
  if (sMode === null) {
    await lf.setItem('s_mode', 'default')
  }
  if (sQuiz === null) {
    await lf.setItem('s_quiz', false)
  }
  if (sText === null) {
    await lf.setItem('s_text', 'new')
  }
  if (sLs === null) {
    await lf.setItem('s_ls', ['无课程'])
  }
  if (sLno === null) {
    await lf.setItem('s_lno', '无课程')
  }
}

export const isBookExist = async (bookId) => {
  const words = await lf.getItem(`book_${bookId}_words`)

  return words !== null
}

export const addBook = async (data) => {
  await initStorage()

  if ('id' in data) {
    const prefix = `book_${data.id}`
    let ret = {
      id: data.id,
    }
    
    if ('name' in data) {
      await lf.setItem(prefix + '_name', data.name)  
      ret['name'] = data.name
    } else {
      console.error('数据格式错误，缺少name')
    }
    
    if ('hasOld' in data && data.hasOld && 'oldType' in data) {
      await lf.setItem(prefix + '_otype', data.oldType)  
      ret['oldType'] = data.oldType
    } else {
      await lf.setItem(prefix + '_otype', '')
      ret['oldType'] = ''
    }

    if ('baseUrl' in data) {
      await lf.setItem(prefix + '_burl', data.baseUrl)  
      ret['baseUrl'] = data.baseUrl
    } else {
      await lf.setItem(prefix + '_burl', '')
      ret['baseUrl'] = ''
    }

    const oldImgInfo = await lf.getItem(prefix + '_img_info')
    if (!oldImgInfo) {
      await lf.setItem(prefix + '_img_info', {})
    }
    
    const oldWords = await lf.getItem(prefix + '_words')
    if (oldWords) {
      ret['progress'] = await lf.getItem(prefix + '_progress')

      // 如果已经存在，则按照id更新之
      if ('words' in data) {
        const wordOBJ = {}
        // 保留旧的
        oldWords.forEach((wordItem) => {
          wordOBJ[wordItem.id] = wordItem
        })
        
        // 加上新的
        const oldCountInfo = await lf.getItem(prefix + '_count')
        data.words.forEach((wordItem) => {
          wordOBJ[wordItem.id] = wordItem
          
          if (!(wordItem.id in oldCountInfo)) {
            oldCountInfo[wordItem.id] = 0
          }
        })
        await lf.setItem(prefix + '_count', oldCountInfo)

        const newWords = Object.values(wordOBJ)
        await lf.setItem(prefix + '_words', newWords)

        ret['words'] = newWords
      } else {
        ret = null
        console.error('数据格式错误，缺少words')
      }
    } else {
      if ('words' in data) {
        await lf.setItem(prefix + '_words', data.words)
        ret['words'] = data.words
      } else {
        ret = null
        console.error('数据格式错误，缺少words')
      }

      await lf.setItem(prefix + '_progress', 0)
      ret['progress'] = 0

      const countInfo = {}
      data.words.forEach((wordItem) => {
        countInfo[wordItem.id] = 0
      })
      await lf.setItem(prefix + '_count', countInfo)
    }

    const allBooks = await lf.getItem('all_books')
    allBooks.push(data.id)
    await lf.setItem('all_books', ld.uniq(allBooks))

    return ret
  } else {
    console.error('数据格式错误，缺少id')

    return false
  }
}

export const getCurBook = async () => {
  return await lf.getItem('cur_book')
}

export const openBook = async (bookId) => {
  await lf.setItem('cur_book', bookId)

  const words = await lf.getItem(`book_${bookId}_words`)

  const lList = []
  let last = ''
  words.forEach((wordItem) => {
    const lno = wordItem.lno
    if (lno !== last) {
      lList.push(lno)
      last = lno
    }
  })
  
  await lf.setItem('s_ls', lList)
  await lf.setItem('s_lno', lList[0])
  await lf.setItem('s_mode', 'default')
  await lf.setItem('s_text', 'new')
}

export const getBasicInfo = async () => {
  await initStorage()

  const lList = await lf.getItem('s_ls')
  const lNo = await lf.getItem('s_lno')
  const textStyle = await lf.getItem('s_text')
  const mode = await lf.getItem('s_mode')
  const quiz = await lf.getItem('s_quiz')

  const bookId = await lf.getItem('cur_book')
  const oldType = await lf.getItem(`book_${bookId}_otype`)
  const baseUrl = await lf.getItem(`book_${bookId}_burl`)
  const bookName = await lf.getItem(`book_${bookId}_name`)

  return {
    lList,
    lNo,
    textStyle,
    mode,
    quiz,
    oldType,
    baseUrl,
    bookName,
  }
}

export const setSetting = async (key, val) => {
  await lf.setItem(key, val)
}

export const getAllWords = async (bookId) => {
  return await lf.getItem(`book_${bookId}_words`)
}

async function getSelectedAndCountInfo(lno, reviewMode) {
  const bookId = await lf.getItem('cur_book')
  const words = await lf.getItem(`book_${bookId}_words`)
  const countInfo = await lf.getItem(`book_${bookId}_count`)
  const selected = reviewMode ? words.filter((wordItem) => parseInt(wordItem.lno) <= parseInt(lno)) : words.filter((wordItem) => wordItem.lno == lno)

  return {
    selected,
    countInfo,
  }
}

export const getBatchWords = async (batchSize, lno, reviewMode) => {
  const { selected, countInfo } = await getSelectedAndCountInfo(lno, reviewMode)
  const retWords = selected.sort((a, b) => countInfo[a.id] - countInfo[b.id])
  return retWords.slice(0, batchSize)
}

export const getWordImgInfo = async () => {
  const bookId = await lf.getItem('cur_book')
  return await lf.getItem(`book_${bookId}_img_info`)
}

export const setWordImg = async (wordId, imgData) => {
  const bookId = await lf.getItem('cur_book')
  const imgInfo = await lf.getItem(`book_${bookId}_img_info`)

  imgInfo[wordId] = imgData
  
  await lf.setItem(`book_${bookId}_img_info`, imgInfo)
}

export const getProgress = async () => {
  const bookId = await lf.getItem('cur_book')
  const progress = await lf.getItem(`book_${bookId}_progress`)

  return progress
}

export const setProgress = async (id) => {
  const bookId = await lf.getItem('cur_book')
  const countInfo = await lf.getItem(`book_${bookId}_count`)
  
  countInfo[id] = countInfo[id] + 1
  await lf.setItem(`book_${bookId}_count`, countInfo)

  let memoedCount = 0
  Object.values(countInfo).forEach((c) => {
    if (c > 0) {
      memoedCount += 1
    }
  })

  const progress = (100 * (memoedCount / Object.values(countInfo).length)).toFixed(2)
  await lf.setItem(`book_${bookId}_progress`, progress)

  return progress
}

export const clearHistory = async () => {
  const bookId = await lf.getItem('cur_book')
  const countInfo = await lf.getItem(`book_${bookId}_count`)
  const newCountInfo = {}
  Object.keys(countInfo).forEach(key => {
    newCountInfo[key] = 0
  })
  await lf.setItem(`book_${bookId}_count`, newCountInfo)
  await lf.setItem(`book_${bookId}_progress`, 0)
}

export const getLessonProgress = async (lno, reviewMode) => {
 const { selected, countInfo } = await getSelectedAndCountInfo(lno, reviewMode)
  let count = 0
  selected.forEach((wordItem) => {
    if (countInfo[wordItem.id] > 0) {
      count += 1
    }
  })

  return (100 * (count / selected.length)).toFixed(2)
}
